// What to do before a user-WebSocket reconnect attempt.
//
// The socket authenticates once, at the upgrade, so the cloud now closes it
// when its access token expires rather than letting it outlive the token
// (ADR 0190 / task ws_session_expiry). On a "stay signed in" session that
// close is expected roughly once a day and means nothing is wrong — but
// reconnecting with the same expired cookie just gets refused again, and the
// hook would sit in its backoff serving a stale screen until some unrelated
// `api()` call happened to renew.
//
// So: renew first, reconnect second. Every other close (network drop, server
// restart, pong timeout) reconnects immediately as before.

import { USER_WS_CLOSE_TOKEN_EXPIRED } from '@neomaris/protocol';

import { renewSession } from './sessionRenewal';

/**
 * Resolve when it is worth reconnecting after `code`.
 *
 * Never rejects and never blocks a reconnect: a failed renewal still resolves,
 * because the socket should retry regardless — a sibling tab may have rotated
 * the session already, and if it really has ended the upgrade is refused and
 * the ordinary backoff takes over.
 */
export async function beforeWsReconnect(code: number): Promise<void> {
  if (code !== USER_WS_CLOSE_TOKEN_EXPIRED) return;
  await renewSession();
}
